import { ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { PageBody } from '@/components/layout/page-header';
import { BuildDetalheView } from './BuildDetalheView';

/** `/versoes/:versao` — o detalhe da versão como página própria (link direto, compartilhável). */
export function VersaoPage() {
  const { versao = '' } = useParams();
  return (
    <PageBody>
      <Link
        to="/feed"
        className="inline-flex w-fit items-center gap-1.5 text-label text-primary underline-offset-4 hover:underline"
      >
        <ArrowLeft className="size-3.5" aria-hidden="true" />
        Voltar ao feed
      </Link>
      <BuildDetalheView
        versao={versao}
        titulo={(texto, className) => <h1 className={className}>{texto}</h1>}
      />
    </PageBody>
  );
}
